<template>
<div class="recognize">
	<div class="title">申请信息</div>
	<Form 
		:model="baseInfo" 
		:label-width="125" 
		ref="form"
		class="mt15">
		<FormItem 
			label="保障起期：" class="w600"
			prop="effectiveDateStart"
			:rules="{required:true,message:'请选择保障起期',type:'date',trigger:'blur'}">
			<DatePicker 
				v-model="baseInfo.effectiveDateStart" 
				type="date" 
				placeholder="请选择保障起期" 
				style="width: 300px" 
				@on-change="dateChange"
				:options="dateOptions">
			</DatePicker>
		</FormItem>
		<FormItem 
			label="保障止期：" class="w600"
			prop="effectiveDateEnd"
			:rules="{required:true,message:'请选择保障止期',type:'date',trigger:'blur'}">
			<DatePicker 
				v-model="baseInfo.effectiveDateEnd" 
				type="date" 
				placeholder="请选择保障止期" 
				style="width: 300px" 
				@on-change="dateEndChange"
				:options="endDateOptions">
			</DatePicker>
		</FormItem>
		<FormItem 
			label="保障天数：" class="w600">
			{{days}}天
		</FormItem>
		<FormItem 
			label="方案：" class="w600">
			{{scheme}}
		</FormItem>
		<p class="download-info mt15">
			<a :href="`/pc/broker/insurance/application/template/export/${bizId}/${baseInfo.productCode}`" target="_blank">下载登记表</a>
			<span class="tips">确认参加本计划车辆信息后再上传</span>
		</p>
		<div class="download-btn mt15">
			<UploadFile	
				:data="uploadParams"
				:disabled="!Boolean(baseInfo.effectiveDateStart&&baseInfo.effectiveDateEnd)"
				:url="`/pc/broker/insurance/application/extraInfo/import/${bizId}/${baseInfo.productCode}`"
				:show-upload-list="false"
				@on-success="handleSuccess" />
		</div>
		<div class="recognize mt15">
			<div class="recognize-title">参加人员信息</div>
			<p class="recognize-total mt10">共{{list.length}}人，费用：{{baseInfo.premium}}元</p>
			<div class="recognize-table mt10">
				<SchemeTable type="car"/>
				<e-table :list="list">
					<el-table-column prop="no" label="序号" width="70" align="center" fixed></el-table-column>
					<el-table-column prop="scheme" label="保障方案" show-overflow-tooltip width="180"></el-table-column>
					<el-table-column prop="seatingCapacity" label="座位数" width="80"></el-table-column>
					<el-table-column prop="premium" label="保费（元）" width="120"></el-table-column>
					<el-table-column prop="carNumber" label="车牌号" width="120"></el-table-column>
					<el-table-column prop="engineNumber" label="发动机号" width="190"></el-table-column>
					<el-table-column prop="frameNumber" label="车架号" width="180"></el-table-column>
					<el-table-column prop="msg" label="情况说明" width="100">
						<template slot-scope="{ row }">
							<span style="color:red" v-if="!row.checkResult.empty">
								{{row.checkResult.result}}
							</span>
							<span style="color:green" v-else>
								校验通过
							</span>
						</template>
					</el-table-column>
				</e-table>
			</div>
			<div class="recognize-title mt15">参加车辆行驶证 
				<span class="tips">每辆车的行驶证照片需上传两页，无相关材料车辆出险后保险公司有权拒赔。</span>
			</div>
			<p v-if="list.length>0&&tableFlag" class="recognize-total mt10">新增车辆（{{list.length}}）</p>
			<FormItem label="上传车辆行驶证：" class="mt15">
				<div v-show="tableFlag">
					<div class="upload" v-for="(item, index) in list" :key="index">
						<UploadFileImg 
							@on-success="val=>uploadSuccess(val,'drivingLicensePhotoFront',index)" 
							:accept="['image']"
							class="upload-item">
							<div class="upload-item-content" v-if="!item.drivingLicensePhotoFront">
								<Icon type="ios-camera" size="20"></Icon>
								<p>第一页</p>
							</div>
							<img 
								:src="ossImg(item.drivingLicensePhotoFront,'s')" 
								v-show="item.drivingLicensePhotoFront" 
								width="100%" 
								style="display:block" />
							<p>{{item.carNumber}}</p>
						</UploadFileImg>
						<UploadFileImg 
							@on-success="val=>uploadSuccess(val,'drivingLicensePhotoEnd',index)" 
							:accept="['image']"
							class="upload-item">
							<div class="upload-item-content" v-if="!item.drivingLicensePhotoEnd">
								<Icon type="ios-camera" size="20"></Icon>
								<p>第二页</p>
							</div>
							<img 
								:src="ossImg(item.drivingLicensePhotoEnd,'s')" 
								v-show="item.drivingLicensePhotoEnd" 
								width="100%" 
								style="display:block" />
							<p>{{item.carNumber}}</p>
						</UploadFileImg>
					</div>
				</div>
			</FormItem>
		</div>
	</Form>
</div>
</template>
<script>
import UploadFile from '../../common/UploadFile'
import SchemeTable from '../common/SchemeTable'
import UploadFileImg from '@/components/common/UploadFileImg'
import eTable from '@/components/common/eTable'
export default {
	components:{ UploadFile,SchemeTable,UploadFileImg,eTable },
	props:{
		info:{
			type:Object,
			default(){
				return {}
			}
		},
	},
	data () {
		return {
			bizId:'TRUCK_EMPLOYERS_LIABILITY_INSURANCE',
			columns:[
                
			],
			list:[],
			baseInfo:{},
			extraInfoUrls:[],
			dateOptions:{
				disabledDate (date) {
					return date&&(date.valueOf()<Date.now())
				}
			},
			endDateOptions:{},
			scheme:this.$route.query.scheme
		}
	},
	computed:{
		days(){
			if(this.baseInfo.effectiveDateStart&&this.baseInfo.effectiveDateEnd){
				return this.getDays(this.formatDate(this.baseInfo.effectiveDateStart),this.formatDate(this.baseInfo.effectiveDateEnd));
			}else {
				return ""
			}
		},
		/*校验是否上传了投保人员*/
		tableFlag () {
			let flag = true;
			this.list.map(item=>{
				if(!item.checkResult.empty){
					flag = false;
				}
			})
			return this.list.length>0&&flag;
		},
		uploadParams(){
			return {
				productCode:this.baseInfo.productCode,
				bizId:this.bizId,
				'baseInfo.effectiveDateStart':this.formatDate(this.baseInfo.effectiveDateStart),
				'baseInfo.effectiveDateEnd':this.formatDate(this.baseInfo.effectiveDateEnd),
				extendField1:this.scheme,
				applicantId:this.info.applicantInfo.enterpriseId
			}
		}
	},
	watch:{
		info(v) {
			this.initData();
		},
		'info.effectiveDateStart'(){
			this.setEndDateOptions()
		}
	},
	created(){
		this.initData();
		if(this.baseInfo.effectiveDateStart){
			this.setEndDateOptions()
		}
	},
	methods:{
		initData(){
			this.baseInfo=this.jsonCopy(this.info.baseInfo);
			if(this.baseInfo.effectiveDateStart)this.baseInfo.effectiveDateStart=new Date(this.baseInfo.effectiveDateStart);
			if(this.baseInfo.effectiveDateEnd)this.baseInfo.effectiveDateEnd=new Date(this.baseInfo.effectiveDateEnd);
			if(this.info.extraInfo&&this.info.extraInfo.length>0){
				this.list=this.info.extraInfo.map(item=>{
					item.checkResult={empty:true}
					return item
				})
			}
			if(!this.extraInfoUrls)this.extraInfoUrls=this.info.extraInfoUrls
		},
		// 保障止期限制
		setEndDateOptions(){
			const that=this;
			let nextYearDay=this.getAfterDay(1,this.baseInfo.effectiveDateStart)
			this.endDateOptions={
				disabledDate (date) {
					return date&&
					(date.valueOf()<=Date.parse(that.baseInfo.effectiveDateStart))||
					(date.valueOf()>Date.parse(nextYearDay))
				}
			}
		},
		/*日期变化后获取起保终保日期*/
		dateChange (value) {
			if(Date.parse(this.baseInfo.effectiveDateEnd)&&Date.parse(value)>=Date.parse(this.baseInfo.effectiveDateEnd)){
				this.$set(this.baseInfo,'effectiveDateEnd','')
			}
			if(value){
				this.setEndDateOptions()
			}
			this.getPremium();
		},
		/*日期变化后获取起保终保日期*/
		dateEndChange (value) {
			this.getPremium();
		},
		/*上传成功后获取数据*/
		handleSuccess (res) {
			this.list = res.data.subjectMatter;
			this.$set(this.baseInfo,'premium',res.data.premium)
			this.$emit('set-amount',res.data.premium)
		},
		/*获取保费*/
		getPremium () {
			if(!this.baseInfo.effectiveDateStart||!this.baseInfo.effectiveDateEnd||this.list.length==0||!this.tableFlag)return;
			let form={
				effectiveDateStart:this.formatDate(this.baseInfo.effectiveDateStart),
				effectiveDateEnd:this.formatDate(this.baseInfo.effectiveDateEnd),
				productCode:this.baseInfo.productCode,
				subjectMatter:this.list,
				bizId:this.bizId,
				applicant:this.info.applicantInfo
			}
			this.$axios.post('/broker/quote.json',form).then(res=>{
				this.$set(this.baseInfo,'premium',res.baseInfo.premium)
				this.list=res.extraInfo;
				this.$emit('set-amount',res.baseInfo.premium)
			})
		},
		// 上传回调方法
		uploadSuccess(val,key,index){
			this.list[index][key]=val.url
			this.$forceUpdate()
		},
		// 校验
		async sub () {
			if(!await this.$refs.form.validate()){
				this.toast('请填写正确的申请信息','error')
				return false
			}
			if(!this.tableFlag){
				this.toast(this.list.length==0?'请上传参加人员信息':'参加人员信息校验失败','error')
				return false
			}
			for(let i=0;i<this.list.length;i++){
				if(!this.list[i].drivingLicensePhotoFront||!this.list[i].drivingLicensePhotoEnd){
					this.toast('请上传行驶证照片','error')
					return false
				}
			}
			return {
				...this.baseInfo,
				effectiveDateStart:this.formatDate(this.baseInfo.effectiveDateStart),
				effectiveDateEnd:this.formatDate(this.baseInfo.effectiveDateEnd),
				extraInfo:this.list,
				extendField1:this.scheme
			}
		},
	}
}
</script>
<style scoped lang="less">
	.download-info{
		font-size: 14px;
	}
	.recognize{
		&-title{
			font-weight: bold;
			font-size: 14px;
		}
		&-total{
			font-size: 14px;
		}
		.tips{
			color:#FF9900;
			margin-left: 20px;
			font-size: 14px;
		}
		&-upload{
			&-item{
				width: 200px;
				text-align: center;
				display: inline-block;
				vertical-align: top;
				font-size: 14px;
				a{
					font-size: 14px;
				}
			}
		}
	}
	
	.upload{
		margin-right: 20px;
		display: inline-block;
		&-item{
			width: 100px;
			display: inline-block;
			margin-right: 10px;
			margin-bottom: 10px;
			&-content{
				padding:10px 0;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/truckEmployer/car/Recognize.vue